import { render, staticRenderFns } from "./pay-card-record.mpx?vue&type=template&id=704ba7b4&scoped=true&component=true&componentId=pay-card-record3e0032df"
import script from "./pay-card-record.mpx?vue&type=script&lang=js&component=true&componentId=pay-card-record3e0032df"
export * from "./pay-card-record.mpx?vue&type=script&lang=js&component=true&componentId=pay-card-record3e0032df"
import style0 from "./pay-card-record.mpx?vue&type=style&index=0&id=704ba7b4&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m3e0032df%22%7D&component=true&componentId=pay-card-record3e0032df"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ba7b4",
  null
  
)

export default component.exports